var map = {
	"./alert/style/index.tsx": "./components/alert/style/index.tsx",
	"./icon/style/index.tsx": "./components/icon/style/index.tsx",
	"./slideshow/style/index.tsx": "./components/slideshow/style/index.tsx"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./components sync recursive ^\\.\\/[^_][\\w]+\\/style\\/index\\.tsx?$";